import React, {Component} from "react";
import PropTypes from 'prop-types'
import './index.css'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {hideSidebarIfFloating} from "../../Redux/Actions/sidebar";

class SidebarItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            height: 0,
            highlighted: false
        };

        this.ref = {
            groupOut: React.createRef(),
            groupIn: React.createRef()
        };
    }

    static defaultProps = {
        icon: null,
        text: '',
        link: null,
        highlighted: false,
        items: null,
        shortcut: null,
        notify: null
    };

    static propTypes = {
        icon: PropTypes.string,
        text: PropTypes.string,
        link: PropTypes.string,
        highlighted: PropTypes.bool,
        items: PropTypes.arrayOf(PropTypes.shape({text: PropTypes.string, link: PropTypes.string, shortcut: PropTypes.string, notify: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), highlighted: PropTypes.bool})),
        shortcut: PropTypes.string,
        notify: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;
        if (props.location !== nextProps.location)
            this.checkUrl(nextProps.location.pathname, nextProps.link);

        return state.height !== nextState.height ||
            state.highlighted !== nextState.highlighted ||
            this.props.location !== nextProps.location ||
            this.props.notify !== nextProps.notify;
    }

    componentDidMount() {
        this.checkUrl();
    }

    render() {
        const {state, props} = this;
        const cls1 = ['SidebarItem'];
        const cls2 = ['SidebarItem-item'];
        const notify = props.items ? props.items.reduce((sum, item) => sum + (parseInt(item.notify) || 0), 0) || null : props.notify;

        state.height && cls1.push('expand');
        notify && cls2.push('notify');
        (props.highlighted || (!state.items && state.highlighted)) && cls2.push('highlighted');

        return <ul className={cls1.join(' ')}>
            <li className={cls2.join(' ')} notify={notify} onClick={this.itemClickHandler.bind(this)}>
                {props.icon && <img className={'SidebarItem-icon'} src={props.icon} alt=""/>}
                <p className={'SidebarItem-title'}>{props.text}</p>
                {props.shortcut && <span className={'SidebarItem-shortcut'}>{props.shortcut}</span>}
            </li>
            <div ref={this.ref.groupOut} className={'SidebarItem-group-block'} style={{height: state.height}}>
                {props.items && <div className="SidebarItem-group" ref={this.ref.groupIn}>
                    {props.items.map((item, index) => <SidebarSubItem key={index} {...item} location={props.location} history={props.history} hideSidebarIfFloating={props.hideSidebarIfFloating}/>)}
                </div>}
            </div>
        </ul>;
    }

    itemClickHandler() {
        if (this.props.link) {
            this.props.history.push(this.props.link);
            this.props.hideSidebarIfFloating();
        }

        if (!this.props.link && this.props.items)
            this.toggleExpandHandler();
    }

    toggleExpandHandler(flag = !Boolean(this.state.height)) {
        const bounding = this.ref.groupIn.current.getBoundingClientRect();

        this.setState({
            height: flag ? bounding.height : 0,
        });
    }

    checkUrl(url = this.props.location.pathname, link = this.props.link) {
        this.setState({
            // eslint-disable-next-line eqeqeq
            highlighted: url == link
        });

        // eslint-disable-next-line eqeqeq
        const item = (this.props.items || []).find(item => item.link == url);

        if (item)
            this.toggleExpandHandler(true);
        else if (this.ref.groupIn.current)
            this.toggleExpandHandler(false);
    }
}

class SidebarSubItem extends Component {
    render() {
        const cls = ['SidebarItem-item'];

        // eslint-disable-next-line eqeqeq
        (this.props.highlighted || this.props.location.pathname == this.props.link) && cls.push('highlighted');
        this.props.notify && cls.push('notify');

        return <li className={cls.join(' ')} notify={this.props.notify} onClick={this.itemClickHandler.bind(this)}>
            <p className={'SidebarItem-title'}>{this.props.text}</p>
            {this.props.shortcut && <span className={'SidebarItem-shortcut'}>{this.props.shortcut}</span>}
        </li>;
    }

    itemClickHandler() {
        this.props.history.push(this.props.link);
        this.props.hideSidebarIfFloating();
    }
}

const mapDispatchToProps = dispatch => {
    return {
        hideSidebarIfFloating: _ => dispatch(hideSidebarIfFloating())
    };
};

export default connect(null, mapDispatchToProps)(withRouter(SidebarItem))